import styled, { css } from 'styled-components'
import { generateMedia } from 'styled-media-query'
import { ReactComponent as SvgLogoUnstyled } from '../../assets/icons/svg/logo.svg'
import { ReactComponent as SvgLogoUnstyled1 } from '../../assets/icons/svg/right-arrow.svg'
import { ReactComponent as SvgLogoUnstyled2 } from '../../assets/icons/svg/sujestion.svg'
import { ReactComponent as SvgLogoUnstyled3 } from '../../assets/icons/svg/warning.svg'

type backgroundTypes={
  url:string
}
type isThirdStepProps={
  isThirdStep?:boolean
}
type SvgArrowProps={
  arrowfill:string
}
const media = generateMedia({
  xs: '350px',
  sm: '668px',
  md: '768px',
  lg: '2000px',
})
export const SvgLogo = styled(SvgLogoUnstyled)`
  --baseHeight: 200px;
  --baseWidth: 200px;

  height: var(--baseHeight);
  width: var(--baseHeight);
  ${media.lessThan('md')`
  height: calc(var(--baseHeight)/1.2625);
  width: calc(var(--baseWidth)/1.2625);
  `}
  ${media.lessThan('sm')`
  height: calc(var(--baseHeight)/1.781);
  width: calc(var(--baseWidth)/1.781);
  `}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight)/2.228);
  width: calc(var(--baseWidth)/2.228);
  `}
`
export const SvgArrowIcon = styled(SvgLogoUnstyled1)<SvgArrowProps>`
 ${({ arrowfill }) => css`
 path{
    fill:${arrowfill};
 }
  --baseHeight: 20px;
  --baseWidth: 20px;

  height: var(--baseHeight);
  width: var(--baseHeight);
  ${media.between('sm', 'md')`
  height: calc(var(--baseHeight)/1.5625);
  width: calc(var(--baseWidth)/1.5625);
  `}
  ${media.between('xs', 'sm')`
  height: calc(var(--baseHeight)/2.181);
  width: calc(var(--baseWidth)/2.181);
  `}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight)/3.428);
  width: calc(var(--baseWidth)/3.428);
  `}
  
`
}
`
export const Wrapper = styled.div`
display: flex;
flex-direction: column;
.startModal{
  display: flex;
  .startModalContainer{
    margin-top: 5%;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    width:100%;
    p{
      font-weight: 600;
    }
  }
}

`
export const Header = styled.div`
 ${css`
margin-left: auto;
margin-right: auto;
left: 0px;
top: 0px;
height: 121px;
display: flex;
justify-content: center;
background: #017849;
border-radius: 0px 0px 25px 25px;
width: 80%;
>svg{
  height: auto;
  }
`
}
`
export const BodyContainer = styled.div`

display: flex;
flex-direction: column;
--baseWidth:56%;
--baseSideMargin:22%;
width: var(--baseWidth);
margin-left: var(--baseSideMargin);
margin-right: var(--baseSideMargin);

${media.between('sm', 'md')`
width: calc(var(--baseWidth)*1.2);
margin-left: calc(var(--baseSideMargin)*1.1);
margin-right: calc(var(--baseSideMargin)*1.1);

  `}
${media.between('xs', 'sm')`
width: calc(var(--baseWidth)x1.3);
margin-left: calc(var(--baseSideMargin)x1.15);
margin-right: calc(var(--baseSideMargin)x1.15);

`}
${media.lessThan('xs')`
width: calc(var(--baseWidth)*1.6);
margin-left: calc(var(--baseSideMargin)*1.3);
margin-right: calc(var(--baseSideMargin)*1.3);

`}

`

export const BackgroundContainer = styled.div<backgroundTypes>`
background-image:url(${({ url }) => url});
background-repeat: no-repeat;
position: absolute;
height: 100%;
margin-top: 12%;
width: 50%;
z-index: -1;

`
export const StepsIconsContainer = styled.div`
${css`
justify-content:center;
padding-top:10%;
padding-right:10%;
padding-bottom:3%;
padding-left:10%;
display: flex;
  
  

  span{
    padding-top: 5%;
    padding-left: 5%;
    padding-right: 5%;
  }
`
}
`
export const StageContainer = styled.div`

`
export const StepsContainer = styled.div<isThirdStepProps>`
${({ isThirdStep }) => css`
height: 48vh;
${media.lessThan('lg')`
  height: 581px;
  `
}
${media.lessThan('lg')`
${isThirdStep && css`
height:681px;`}
`}
${media.lessThan('sm')`
${isThirdStep && css`
height:781px;`}
`}
`}
`

export const SugestionsContainer = styled.div`
position: fixed;
bottom: 0;
right: 0;
`
export const SvgSugestion = styled(SvgLogoUnstyled2)`
  --baseHeight: 113px;
  --baseWidth: 113px;
  cursor: pointer;
  height: var(--baseHeight);
  width: var(--baseHeight);
  ${media.lessThan('md')`
  height: calc(var(--baseHeight)/1.5625);
  width: calc(var(--baseWidth)/1.5625);
  `}
  ${media.lessThan('sm')`
  height: calc(var(--baseHeight)/2.181);
  width: calc(var(--baseWidth)/2.181);
  `}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight)/3.428);
  width: calc(var(--baseWidth)/3.428);
  `}

`
export const SvgWarning = styled(SvgLogoUnstyled3)`
  --baseHeight: 150px;
  --baseWidth: 150px;
  height: var(--baseHeight);
  width: var(--baseHeight);
  ${media.lessThan('md')`
  height: calc(var(--baseHeight)/1.5625);
  width: calc(var(--baseWidth)/1.5625);
  `}
  ${media.lessThan('sm')`
  height: calc(var(--baseHeight)/2.181);
  width: calc(var(--baseWidth)/2.181);
  `}
  ${media.lessThan('xs')`
  height: calc(var(--baseHeight)/3.428);
  width: calc(var(--baseWidth)/3.428);
  `}

`
export const ModalTitleContainer = styled.div`
display: flex;
flex-direction: column;
`
export const ModalInputContainer = styled.div`
.input{
  margin: 5% auto;
  width: 90%;
}
.textarea-container{
  margin: auto;
  width: 90%;
}
.stepButton{
  margin-left: 5%;
  width: 90%; 
}
label{
  font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 17px;
}
${media.lessThan('sm')`
  width:100%;
  `}
margin-top: 1%;
width: 50%;
height: 100%;
display: flex;
flex-direction: column;
padding-bottom: 5%;
gap: 200px;

`
export const ModalImageContainer = styled.div`
padding: 1% 3% 3%;
width: 50%;
height: 100%;
display: flex;
flex-direction: column;
${media.lessThan('sm')`
  width:100%;
  `}
h1{
font-family: 'Comfortaa';
font-style: normal;
font-weight: 400;
font-size: 25px;
line-height: 33px;
color: #000000;
}
h2{
  font-family: 'Comfortaa';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 18px;
color: #828282;
}

img{
margin-top: 17%;
max-width: fit-content;
max-height: fit-content;
}
`
